import React from 'react';
import { expertise } from '../data/mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Heart, Shield, Wind, Activity, Users, HeartHandshake } from 'lucide-react';

const iconMap = {
  Heart,
  Shield,
  Wind,
  Activity,
  Users,
  HeartHandshake
};

const Expertise = () => {
  return (
    <section id="expertise" className="py-20 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Areas of Expertise
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Specialized cancer care with international training and evidence-based treatment approaches
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {expertise.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <Card key={item.id} className="hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <CardHeader>
                  <div className="inline-flex items-center justify-center w-14 h-14 bg-teal-100 rounded-xl mb-4">
                    <Icon className="w-7 h-7 text-teal-700" />
                  </div>
                  <CardTitle className="text-xl">{item.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base">{item.description}</CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Expertise;